import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  const scrollToCTA = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById('money-cta');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="py-6 md:py-14 px-4 md:px-6 bg-navy text-cream text-center relative overflow-hidden" data-id="element-59">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-60"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-61">
        <FadeIn data-id="element-62">
          <h2 className="font-serif text-xl md:text-2xl text-gold mb-3 md:mb-5" data-id="element-63">
            Your Financial Reset Starts Here
          </h2>
        </FadeIn>

        <FadeIn delay={200} data-id="element-64">
          <div className="space-y-2 text-sm md:text-base font-light text-cream/90 mb-5 md:mb-7" data-id="element-65">
            <p data-id="element-66">The problem isn't that you're bad with money.</p>
            <p data-id="element-67">The problem is that your brain learned a spending pattern.</p>
            <p className="mt-2 italic text-cream/60 text-xs md:text-sm" data-id="element-68">
              And what the brain learns… it can also unlearn.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={400} data-id="element-69">
          <a href="#money-cta" onClick={scrollToCTA} className="inline-block bg-gold text-navy font-semibold text-sm md:text-lg px-7 md:px-10 py-3 md:py-4 rounded-full transition-transform duration-300 hover:scale-105 hover:shadow-xl hover:shadow-gold/20" data-id="element-70">
            Take Back Control
          </a>
        </FadeIn>
      </div>
    </section>;
}